import {
  NotificationType,
  PushNotification,
  PushNotificationFormatted,
  ScheduledNotification,
  ScheduledNotificationFormatted,
} from './types';
import { TargetGroup, translateTargetGroupNicely } from 'ck-queries';

import dayjs from 'dayjs';
import { standardDateFormat } from 'ck-utils';

/**
 * Takes in notifications from server and formats objects into strings to display in table.
 *
 * @param notifications - PushNotifications from server
 * @returns - Formatted PushNotifications to work with table implementation
 */
export const formatPushNotifications = (notifications: PushNotification[]) => {
  if (!notifications) return []; // Nullcheck

  return notifications.map(
    ({ targetGroup, totalSeen, totalSent, date, type, ...rest }) => {
      return {
        ...rest,
        type,
        ...convertValuesToStrings(date, targetGroup, type),
        openingStats: `${totalSeen} st av ${totalSent} st`,
      } as PushNotificationFormatted;
    }
  );
};

export const formatScheduledPushNotifications = (
  notifications: ScheduledNotification[]
) => {
  if (!notifications) return [];

  return notifications.map(
    ({ targetGroup, date, type, ...rest }) =>
      ({
        ...rest,
        type,
        ...convertValuesToStrings(date, targetGroup, type),
        scheduleTime: dayjs(rest.scheduleTime).format('YYYY-MM-DD HH:mm'),
        scheduleTimeFormatted: dayjs(rest.scheduleTime).format(
          standardDateFormat
        ),
      } as ScheduledNotificationFormatted)
  );
};

// Helper function
const convertValuesToStrings = (
  date: string,
  targetGroup: TargetGroup,
  type: NotificationType
) => {
  return {
    date: dayjs(date).format(standardDateFormat),
    targetGroupString: translateTargetGroupNicely(targetGroup),
    typeString: type === 'Alarm' ? 'Larm' : 'Pushnotis',
    targetGroup,
  };
};
